import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Quanto è sicuro?",
    answer: "La sicurezza è la nostra priorità assoluta. Tutti i dati sono protetti con crittografia end-to-end di livello militare. Solo tu e i tuoi familiari autorizzati avete accesso alle conversazioni. Non condividiamo mai dati con terze parti.",
  },
  {
    question: "Posso modificare qualcosa in seguito?",
    answer: "Assolutamente sì. Il processo è iterativo: puoi modificare, aggiungere o rimuovere contenuti in qualsiasi momento finché non sei completamente soddisfatto del risultato. Il tuo profilo digitale è sempre sotto il tuo controllo.",
  },
  {
    question: "E se non sono ancora pronto?",
    answer: "Non c'è fretta. Puoi iniziare con il piano Accesso Anticipato a soli €10 e provare il servizio senza impegno. Quando sarai pronto ad approfondire, potrai passare a un piano superiore in qualsiasi momento.",
  },
  {
    question: "Per quanto tempo verranno conservate le informazioni?",
    answer: "I tuoi dati vengono conservati a tempo indeterminato sui nostri server sicuri. Il nostro obiettivo è preservare la tua presenza digitale per le generazioni future. Offriamo anche opzioni di backup locale per una sicurezza aggiuntiva.",
  },
  {
    question: "Come funziona la ricostruzione della voce?",
    answer: "Utilizziamo algoritmi avanzati di intelligenza artificiale per analizzare le registrazioni vocali che ci fornisci. Più materiale audio carichi, più accurata sarà la ricostruzione del timbro, dell'intonazione e delle caratteristiche uniche della voce.",
  },
  {
    question: "Su quali piattaforme posso ricevere i messaggi?",
    answer: "Attualmente supportiamo WhatsApp, Telegram e Facebook Messenger. Stiamo lavorando per integrare anche altre piattaforme. Puoi scegliere la tua preferita durante la configurazione.",
  },
];

export const FaqSection = () => {
  return (
    <section id="faq" className="py-24 lg:py-32 bg-gradient-section-alt relative">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Domande e risposte
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border/40 rounded-xl px-6 shadow-card data-[state=open]:shadow-medium transition-shadow duration-300"
              >
                <AccordionTrigger className="text-left font-serif text-base font-semibold text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
